const cards = [
  {
    title: '鬼灭之刃 全集',
    desc: '大正时代，少年灶门炭治郎全家被鬼杀害，妹妹祢豆子变成鬼，他踏上斩鬼之旅。热血战斗漫画全集，感动千万读者。',
    tag: '热血·完结',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20young%20warrior%20with%20sword%20in%20traditional%20setting%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20dark%20tones%2C%20clean%20cream%20background%2C%20high%20quality%20anime%20art&width=800&height=600&seq=card-manga-01&orientation=landscape',
    stats: '205话',
  },
  {
    title: '咒术回战 全集',
    desc: '高中生虎杖悠仁吞下宿傩手指成为咒术师，与伙伴们对抗诅咒。精彩咒术战斗，日漫全集必看之作。',
    tag: '战斗·完结',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20modern%20sorcerer%20with%20dark%20energy%20effects%2C%20urban%20fantasy%20setting%2C%20warm%20dramatic%20lighting%2C%20clean%20cream%20background%2C%20stylized%20Japanese%20manga%20art&width=800&height=600&seq=card-manga-02&orientation=landscape',
    stats: '271话',
  },
  {
    title: '我心属于你 全集',
    desc: '校园青春恋爱韩漫，男女主角从误会到相知相爱，甜蜜中带泪。韩漫全集高人气作品，下拉式一口气看完。',
    tag: '恋爱·完结',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romantic%20scene%20with%20two%20young%20characters%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20tones%2C%20gentle%20atmosphere%2C%20clean%20illustration%20with%20subtle%20texture&width=800&height=600&seq=card-manga-03&orientation=landscape',
    stats: '120话',
  },
  {
    title: '进击的巨人 全集',
    desc: '人类被巨人围困于高墙之内，少年艾伦追求自由与真相。史诗级日漫全集，颠覆性剧情，漫画大全经典。',
    tag: '奇幻·完结',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20manga%20illustration%20of%20a%20giant%20titan%20breaching%20massive%20walls%2C%20epic%20scale%20with%20human%20figures%2C%20warm%20earthy%20tones%20with%20cream%20background%2C%20cinematic%20composition&width=800&height=600&seq=card-manga-04&orientation=landscape',
    stats: '139话',
  },
  {
    title: '间谍过家家 全集',
    desc: '间谍、杀手、超能力少女组成的虚假家庭，温馨搞笑又刺激。日漫全集人气王，治愈系+动作完美融合。',
    tag: '搞笑·完结',
    img: 'https://readdy.ai/api/search-image?query=Playful%20manga%20illustration%20of%20a%20quirky%20family%20with%20a%20gentleman%20spy%2C%20assassin%20woman%20and%20telepathic%20child%2C%20warm%20humorous%20tone%2C%20clean%20cream%20background%2C%20stylish%20anime%20art&width=800&height=600&seq=card-manga-05&orientation=landscape',
    stats: '103话',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          完结漫画精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          精选高分完结漫画全集，每一部都值得从头看到尾
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href={`#carousel`}
              className="group block bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={`亲亲漫画网 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-600">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-600">
                  {card.stats}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}